var view = document.querySelector('.reports-view');

if (view) {
    var m = require('../modules/Reports');
    (new m(view, {}));
}